import './home-amount.scss'
import Trade from "../../../assets/images/icons/transaction.png";
import Chevron from "../../../assets/images/icons/chevron-down.png";
import WarningRounded from "../../../assets/images/icons/warning-rounded.png";
import Arrows from "../../../assets/images/icons/exchange.png";
import Timer from "../../../assets/images/icons/timer.png";

import React, { useEffect, useState } from 'react'
import { ActionButton } from '../../utils/action-button/actionButton'
import { Amount } from '../../utils/amount/amount'
import { Keypad } from '../../utils/keypad'
import { createPayment, getPaymentChargeLoader, getPaymentCreationError, getPaymentCreationInfo, getPurchase, getQuotationInfo, getQuotations, setPaymentChargeLoader, setPaymentCreationError, setPurchase } from '../../../store/TransactionSlice'
import { useAppDispatch, useAppSelector } from '../../../features'
import { StepProps } from '../../../types/helpers'
import { PaymentLoader } from '../../utils/loader/loader';
import { getUserInfo } from '../../../store/UserSlice';
import { getRefreshToken } from '../../../store/EncryptionSlice';
import { HomeCardAccountInfo } from './components/home-wallet';
import { ExchangeRate } from './components/exchange-rate';
import { purchaseError } from '../../../utils/textFormatter';
import { MaintenanceCard } from './components/maintenance';

export const topLimitAmount = 1000000000;
const version = 0.991;
// Add Home Currency

export const CURRENCIES = {
    usd: "USDT",
    br: "BRL",
    //trx: "TRX",
    //btc: "BTC"
} as const;

export type CurrencyType = typeof CURRENCIES[keyof typeof CURRENCIES];

export const HomeAmount: React.FC<StepProps> = (props) => {

    const dispatch = useAppDispatch();  
    
    const token                 = useAppSelector(getRefreshToken);
    const quotations            = useAppSelector(getQuotationInfo);
    const purchase              = useAppSelector(getPurchase);
    const creationPayment       = useAppSelector(getPaymentCreationInfo);
    const creationPaymentLoader = useAppSelector(getPaymentChargeLoader);
    const userInfo  : any       = useAppSelector(getUserInfo);
    const creationPaymentError  = useAppSelector(getPaymentCreationError);

    // MOCK
    const pairList = CURRENCIES;
    
    //const pairList                  = useAppSelector(getAvailable);
    const [tokens, setTokens]       = useState<Array<CurrencyType>>(['USDT',`BRL`]);
    const [currency, setCurrency]   = useState<CurrencyType>(CURRENCIES.usd);
    const [base, setBase]           = useState<CurrencyType>(CURRENCIES.br);
    const [basemenu, setBasemenu]   = useState<boolean>(false);

    
    const [wallet,setWallet]    = useState<string | null>(null);
    const [pair,setPair]        = useState<string>(`USDT:fiatBRL`);
    const [val, setVal]         = useState(0);
    const [limit, setLimit]     = useState<boolean>(false);
    const [menu, setmenu]       = useState<boolean>(false);

    // modal
    const [showInfoModal, setShowInfoModal] = useState<boolean>(false);

    const handleChangeValue = (value: number) => {

        if (value > topLimitAmount) setLimit(true);
        else setLimit(false);

        const val = Number((value/100).toFixed(2));
        setVal(val);
        dispatch(setPurchase(val));
    }

    const handleCreateQrCode = () => {

        dispatch(setPaymentChargeLoader(true));
        
        // quote_amount: null, // fiat brl -- if amount is brl
        // amount: purchase.value, // base amount - if usdt amount
        const paymentCreationObject : any = {
            pair: pair, 
            pay_method: 'qrcode'
        }

        if (base === `BRL`) {
            paymentCreationObject[`quote_amount`] = purchase.value
            localStorage.setItem('currentPayment','BRL');
        } else {
            paymentCreationObject[`amount`] = purchase.value
            localStorage.setItem('currentPayment','USDT');
        }

        dispatch(createPayment(paymentCreationObject))
    }    

    // timer update api
    const updateTime: number = 20000;

    useEffect( () => {
        setWallet(userInfo?.wallet?.hash_address)
    }, [userInfo])

    useEffect(() => {

        const timer = setTimeout(() => {
            dispatch(getQuotations('USDT:fiatBRL'));
            clearTimeout(timer);
        }, (updateTime/20) );
        const interval = setInterval(() => {
            dispatch(getQuotations('USDT:fiatBRL'));
        }, updateTime);

        if (Object.keys(creationPayment).length > 0) {
            const timer = setTimeout(() => {
                clearTimeout(timer);
                dispatch(setPaymentChargeLoader(false))
                props.increaseStep();
            }, (updateTime/20) )
        }
        
        return () => { clearInterval(interval) }

    }, [dispatch, props, creationPayment]);

    useEffect( () => {

        if (creationPaymentError) {
            const timer = setTimeout(() => {
                dispatch(setPaymentCreationError(``))
                clearTimeout(timer);
            }, 4000);
        }

        /*
        if (pairList) {
            setTokens(pairList);
        }
        */

    },[creationPaymentError, pairList])


    const handleSwapCurrency = (currency:CurrencyType) => {
        setBase(currency);
        setCurrency(currency === CURRENCIES.usd ? CURRENCIES.br : CURRENCIES.usd);
        setVal(0);
        dispatch(setPurchase(0));
    }

    const openMenu = (menuFilter: string) => {
        if (menuFilter === 'target') setmenu(!menu);
        else setBasemenu(!basemenu);
    }

    const showModalInfoClick = () => {
        setShowInfoModal(!showInfoModal);
    }



    return (
        <div className='Home'>

            {creationPaymentLoader && (
                <PaymentLoader />
            )}

            <div className="amount-wrapper">

                <MaintenanceCard />

                <h2 className='poppins-bold'>
                    Quantidade da moeda que deseja 
                    { currency.toLowerCase() === 'usdt' ? ' cotar' : ' cotar'} : <img src={WarningRounded} alt='icon warning' onClick={showModalInfoClick} />
                </h2>
                &nbsp;

                <div
                    className={`exchange ${basemenu ? 'active' : null}`}
                    onClick={ () => openMenu('base')}>
                    <div className="exchange-selected">
                        <img className='trade' src={Trade} alt="" />
                        <span>{base}</span>
                        <img src={Chevron} alt="" className={`${basemenu ? 'active' : null}`} />
                    </div>
                    <ul>
                        { tokens.map((token, index) => (
                            <li key={index} onClick={() => handleSwapCurrency(token)}> {token} </li>
                        ))}
                    </ul>
                </div>

                <Amount value={val} currency={base} mini={true}/>

                <div 
                    className={`exchange offline ${menu ? 'active' : null}`}>
                    <div className="exchange-selected">
                        <img className='trade' src={Trade} alt="" />
                        <span>{currency}</span>
                        <img src={Chevron} alt="" className={`${menu ? 'active' : null}`} />
                    </div>
                    <ul>
                        { tokens.map((token, index) => (
                            <li key={index} onClick={() => handleSwapCurrency(token)}> {token} </li>
                        ))}
                    </ul>
                </div>

                <div className='amount-result'>
                    <ExchangeRate value={val} price={quotations?.price} currency={base}/>
                </div>
            </div>

            <Keypad onChange={handleChangeValue} />

            <HomeCardAccountInfo />
            
            { (token) && 
                <ActionButton
                    label='Gerar QR Code'
                    stylish='btn-green three'
                    onClick={handleCreateQrCode}
                    disabled={!token || val < 1 || limit} 
                />
            }
            
            { limit && (
                <p className='top-limit'>Limit máximo para compras é de 10.000.000,00 (10 milhões de reais)</p>
            )}

            { creationPaymentError && creationPaymentError !== '' && 
            <>
                <p className="alert alert-danger">
                    { purchaseError(creationPaymentError) }
                </p>
            </>}

            <p className='version'>
                versão: {version}
            </p>

            <div className={`card modal-exchange ${showInfoModal ? 'active' :  ''}`}>
                
                <div className="card-body">
                    
                    <h1>Modelos de troca</h1>

                    <div className="modal-card">
                        <h2>
                            <span className="brl">
                                BRL
                            </span>
                            <span className='img'>
                                <img src={Arrows} alt="" />
                            </span>
                            <span className="usdt">
                                USDT
                            </span>
                        </h2>
                        <p className='poppins-regular'>
                            Ao realizar a compra em Reais (BRL), a conversão será feita com base na cotação do Dólar (USD) no momento da transação. O valor pode variar, e o montante exibido pode não corresponder ao valor final cobrado. Se a conversão automática estiver ativada, ela ocorrerá na compra; caso contrário, será feita apenas no saque.
                        </p>
                        <div className="buttons">
                            <div className="label label-info">
                                <img src={Timer} alt=''/>Troca instantânea
                            </div>
                        </div>
                    </div>
                    <div className="modal-card">
                        <h2>
                            <span className="usdt">
                                USDT
                            </span>
                            <span className='img'>
                                <img src={Arrows} alt="" />
                            </span>
                            <span className="brl">
                                BRL
                            </span>
                        </h2>
                        <p className='poppins-regular'>Ao realizar a compra de USDT, garantimos a cotação por até 5 (cinco) minutos. Caso, durante esse período, o valor do Dólar (USD) varie mais de 1%, a operação será cancelada automaticamente e você será notificado.</p>
                        <div className="buttons">
                            <div className="label label-info">
                                <img src={Timer} alt=''/>300 segundos garantido
                            </div>
                        </div>
                    </div>
                </div>

                <hr />

                <div className="card-footer">
                    <button className='btn' onClick={showModalInfoClick}>
                        Entendi
                    </button>
                </div>
            </div>
            <div className={`shadow ${showInfoModal ? 'active' :  ''}`}></div>

        </div>

    )
}